/** Rola o wizard de agendamento para o topo (janela + container scroll do layout). */
export function scrollSchedulingWizardToTop(behavior: ScrollBehavior = 'auto') {
	window.scrollTo({ top: 0, left: 0, behavior });

	const scrollContainers = document.querySelectorAll<HTMLElement>(
		'main section.overflow-y-scroll, main section.overflow-y-auto',
	);

	scrollContainers.forEach((element) => {
		element.scrollTo({ top: 0, left: 0, behavior });
	});
}
